import React, { useCallback, useEffect, useMemo, useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import uuid from 'uuid'

import { useCmsContent } from '../cms/useCmsContent'
import { RequestForm } from './RequestForm'
import { RequestFormHeader } from './RequestFormHeader'
import { RequestFormCompleted } from './RequestFormCompleted'
import settings from '../settings'
import tracker from '../../../utils/tracker'
import { getState, saveState } from '../../../utils/state'
import { toSimpleService } from '../../containers/bada/utils'

const Styles = createGlobalStyle`
  :root {
    --primary: #192228;
    --border: rgba(25, 34, 40, 0.5);
  }
`

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;

  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  color: var(--primary);

  label {
    font-weight: 400;
    margin-bottom: 0;
  }

  h2,
  h3,
  h4,
  h5 {
    font-family: 'NewSpirit';
  }
`

export const WebsiteForm = ({ serviceCode, serviceId, storeId }) => {
  const { services } = useCmsContent()
  const [completed, setCompleted] = useState(false)

  const [uiState, setUiState] = useState({
    storeId: null,
    selectedAddress: null,
    selectedStore: null,
    selectedService: null,
    selectedSlot: null,
    selectedServiceProviderEmail: null,
    selectedServiceProvider: null,
    booking: null,
    bookingCompleted: false,
    customerForm: null,
    prepCompleted: false,
    prepData: {
      questions: [],
    },
    appointmentId: null,
    visitorId: null,
  })

  const service = useMemo(
    () => services.find((s) => s.id === +serviceId && s.code === serviceCode),
    [services]
  )

  useEffect(() => {
    saveState(uiState, settings.brand)
  }, [uiState])

  useEffect(() => {
    const savedState = getState(settings.brand) || { visitorId: uuid() }

    if (savedState && !savedState.visitorId) {
      savedState.visitorId = uuid()
    }

    setUiState((s) => ({
      ...s,
      visitorId: saveState.visitorId,
    }))

    tracker.trackInitVisitor('BADA 2.0 init visitor', savedState.visitorId)
  }, [])

  const updateUiState = useCallback((partialState) => {
    setUiState((s) => ({ ...s, ...partialState }))
  }, [])

  useEffect(() => {
    updateUiState({
      selectedService: service ? toSimpleService(service) : null,
    })
  }, [service, updateUiState])

  if (!service) {
    return (
      <p>
        Could not find service with code &apos;{serviceCode}&apos; and id &apos;
        {serviceId}&apos;
      </p>
    )
  }

  if (service.serviceType !== 'customerform') {
    return <p>Only form appointments are supported</p>
  }

  return (
    <Container>
      <Styles />
      <RequestFormHeader service={service} hideText={completed} />
      {completed ? (
        <RequestFormCompleted service={service} />
      ) : (
        <RequestForm
          storeId={storeId}
          service={service}
          onCreated={() => setCompleted(true)}
          updateUiState={updateUiState}
        />
      )}
    </Container>
  )
}
